<style scoped>
    @font-face {
            font-family: SourceSansPro-Regular;
            src: url(../assets/fonts/SourceSansPro-Regular.ttf);
        }

        .clearfix:after {
          content: "";
          display: table;
          clear: both;
        }

        a {
          color: #0087C3;
          text-decoration: none;
        }

        body {
          position: relative;
          width: 21cm;
          height: 29.7cm;
          margin: 0 auto;
          color: #000;
          background: #FFFFFF;
          font-family: SourceSansPro-Regular.ttf;
          font-size: 12px;
          font-family: SourceSansPro-Regular.ttf;
        }

        .doublepass {
          position: relative;
          width: 9.5cm;
          height: 14cm;
        }

        header {
          padding: 1px 0;
          margin-bottom: 2px;
          border-bottom: 1px solid #AAAAAA;
        }

        #logo {
          float: left;
          margin-top: 8px;
        }

        #logo img {
            height: 70px;
        }

        #company {
          float: center;
          text-align: center;
        }

        #passdetails {
          padding-right: 6px;
          float: right;
          text-align: left;
        }

        #taxinvoice {
          float: center;
          text-align: center;
          width: 100%;
          font-size: 1.4em;
          font-weight: bold;
          text-transform: uppercase;
        }


        #details {
          margin-bottom: 2px;
        }

        #client {
          padding-left: 2px;
          border-left: 6px solid #0087C3;
          float: left;
        }

        #client .to {
          color: #000;
        }

        h2.name {
          font-size: 1.0em;
          font-weight: normal;
          margin: 0;
        }

        #invoice {
          float: right;
          text-align: right;
        }

        #invoice h1 {
          color: #000;
          font-size: 1.2em;
          line-height: 0.2em;
          font-weight: normal;
          margin: 0  0 1px 0;
        }

        #invoice .date {
          font-size: 1.0em;
          color: #000;
        }

        #invoice .line {
          font-size: 1.2em;
          color: #000;
          font-weight: bold;
        }

        

        #taxable {
          text-align: center;
        }

        #id {
            text-align: left;
            font-size: 1.0em;
            background: #fff;
        }

        #thanks{
          font-size: 1em;
          margin-bottom: 50px;
        }

        #notices{
          padding-left: 6px;
          border-left: 6px solid #0087C3;
        }

        #notices .notice {
          font-size: 1.2em;
        }

        footer {
          color: #000;
          width: 100%;
          height: 25px;
          position: absolute;
          padding: 8px 0;
          text-align: center;
        }


</style>

<template>
    <v-layout>
        <body>
            <div class="doublepass">
                <header class="clearfix">
                    <div id="logo">
                        <img src="../assets/logo.png" class="d-inline-block align-top" alt="">
                    </div>
                    <div id="company">
                        <h2 class="name" style="font-weight: bold;">VILSONS CONTAINER FREIGHT STATION</h2>
                        <div style="font-size: 10px;">(A Unit of Vilsons Shipping Private Limited)</div>
                        <div style="font-weight: bold;">33AAACV6328H1ZF</div>
                        <div style="font-size: 10px;">3/2B, Harbour Express Road, Near Camp I, Tuticorin - 628 006</div>
                        <div style="font-size: 10px;">Ph.No.: 0461-2352955,2352055,7373012055 | vilsons.cfs@gmail.com | www.cfs.vilsonsshipping.com</div>
                    </div>
                    <div style="text-align: center; font-size: 16px; font-weight: bold;">IMPORT GATE IN PASS
                    </div>
                    <div id="details" class="clearfix">
                        <div id="client">
                            <h2 class="name" style="font-weight:bold;">Pass No.:&nbsp;{{ gin_pass_details.pass_no }}</h2>
                            <h2 class="name" style="font-weight:bold;">In Date&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;{{ gin_pass_details.in_date }}</h2>
                            <h2 class="name">IGM&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;{{ gin_pass_details.igm_no }} &amp; {{ gin_pass_details.igm_date }}</h2>
                            <h2 class="name">BL No.&nbsp;:&nbsp;{{ gin_pass_details.bl_no }} &amp; {{ gin_pass_details.bl_date }}</h2>
                            <h2 class="name">Line&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;{{ gin_pass_details.line }}</h2>
                            <h2 class="name">Cargo&nbsp;&nbsp;:&nbsp;{{ gin_pass_details.cargo }}</h2>
                            <h2 class="name">Port Out Time:&nbsp;{{ gin_pass_details.port_out_time }}</h2>
                            <h2 class="name">Work No.:&nbsp;{{ gin_pass_details.job_order_no }}</h2>
                        </div>
                    </div>
                    <hr />
                    <div id="details" class="clearfix">
                        <div id="client">
                            <h2 class="name" style="font-weight:bold;">Container:&nbsp;{{ gin_pass_details.cont_no }}</h2>
                            <h2 class="name" style="font-weight:bold;">Size/type&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;{{ gin_pass_details.size_type }}</h2>
                            <h2 class="name">Seal No.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;{{ gin_pass_details.seal_no }}</h2>
                            <h2 class="name" style="font-weight:bold;">Truck No&nbsp;:&nbsp;{{ gin_pass_details.truck_no }}</h2>
                            <h2 class="name">Vessel/voyage&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;{{ gin_pass_details.vessel }} &amp; {{ gin_pass_details.voyage }}</h2>
                            <h2 class="name">EIR No&nbsp;&nbsp;:&nbsp;{{ gin_pass_details.eir_no }}</h2>
                            <h2 class="name" style="font-weight:bold;">Scanned:&nbsp;{{ gin_pass_details.is_scanned }}</h2>
                            <h2 class="name">Transporter&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;{{ gin_pass_details.transporter }}</h2>
                            <h2 class="name">Importer&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;{{ gin_pass_details.importer }}</h2>
                        </div>
                    </div>
                    <br />
                    <div id="invoice" class="clearfix">
                        <div id="passdetails">
                            <h2 class="name" style="font-weight:bold;">{{ gin_pass_details.created_by }}</h2>
                            <h2 class="name" style="font-weight:bold;">Authorised Signature</h2>
                        </div>
                    </div>
                    <br />
                    <div id="details" class="clearfix">
                        <div id="passdetails">
                            <h2 class="name" style="font-size:8px;">This is generated on a computer and is valid without the signature and seal.For enquiry please mail us on managercfs@vilship.com. Thanks for your business!</h2>
                        </div>
                    </div>
                </header>
            </div>
            <div class="doublepass">
                <header class="clearfix">
                    <div id="logo">
                        <img src="../assets/logo.png" class="d-inline-block align-top" alt="">
                    </div>
                    <div id="company">
                        <h2 class="name" style="font-weight: bold;">VILSONS CONTAINER FREIGHT STATION</h2>
                        <div style="font-size: 10px;">(A Unit of Vilsons Shipping Private Limited)</div>
                        <div style="font-weight: bold;">33AAACV6328H1ZF</div>
                        <div style="font-size: 10px;">3/2B, Harbour Express Road, Near Camp I, Tuticorin - 628 006</div>
                        <div style="font-size: 10px;">Ph.No.: 0461-2352955,2352055,7373012055 | vilsons.cfs@gmail.com | www.cfs.vilsonsshipping.com</div>
                    </div>
                    <div style="text-align: center; font-size: 16px; font-weight: bold;">IMPORT GATE IN PASS
                    </div>
                    <div id="details" class="clearfix">
                        <div id="client">
                            <h2 class="name" style="font-weight:bold;">Pass No.:&nbsp;{{ gin_pass_details.pass_no }}</h2>
                            <h2 class="name" style="font-weight:bold;">In Date&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;{{ gin_pass_details.in_date }}</h2>
                            <h2 class="name">IGM&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;{{ gin_pass_details.igm_no }} &amp; {{ gin_pass_details.igm_date }}</h2>
                            <h2 class="name">BL No.&nbsp;:&nbsp;{{ gin_pass_details.bl_no }} &amp; {{ gin_pass_details.bl_date }}</h2>
                            <h2 class="name">Line&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;{{ gin_pass_details.line }}</h2>
                            <h2 class="name">Cargo&nbsp;&nbsp;:&nbsp;{{ gin_pass_details.cargo }}</h2>
                            <h2 class="name">Port Out Time:&nbsp;{{ gin_pass_details.port_out_time }}</h2>
                            <h2 class="name">Work No.:&nbsp;{{ gin_pass_details.job_order_no }}</h2>
                        </div>
                    </div>
                    <hr />
                    <div id="details" class="clearfix">
                        <div id="client">
                            <h2 class="name" style="font-weight:bold;">Container:&nbsp;{{ gin_pass_details.cont_no }}</h2>
                            <h2 class="name" style="font-weight:bold;">Size/type&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;{{ gin_pass_details.size_type }}</h2>
                            <h2 class="name">Seal No.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;{{ gin_pass_details.seal_no }}</h2>
                            <h2 class="name" style="font-weight:bold;">Truck No&nbsp;:&nbsp;{{ gin_pass_details.truck_no }}</h2>
                            <h2 class="name">Vessel/voyage&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;{{ gin_pass_details.vessel }} &amp; {{ gin_pass_details.voyage }}</h2>
                            <h2 class="name">EIR No&nbsp;&nbsp;:&nbsp;{{ gin_pass_details.eir_no }}</h2>
                            <h2 class="name" style="font-weight:bold;">Scanned:&nbsp;{{ gin_pass_details.is_scanned }}</h2>
                            <h2 class="name">Transporter&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;{{ gin_pass_details.transporter }}</h2>
                            <h2 class="name">Importer&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;{{ gin_pass_details.importer }}</h2>
                        </div>
                    </div>
                    <br />
                    <div id="invoice" class="clearfix">
                        <div id="passdetails">
                            <h2 class="name" style="font-weight:bold;">{{ gin_pass_details.created_by }}</h2>
                            <h2 class="name" style="font-weight:bold;">Authorised Signature</h2>
                        </div>
                    </div>
                    <br />
                    <div id="details" class="clearfix">
                        <div id="passdetails">
                            <h2 class="name" style="font-size:8px;">This is generated on a computer and is valid without the signature and seal.For enquiry please mail us on managercfs@vilship.com. Thanks for your business!</h2>
                        </div>
                    </div>
                </header>
            </div>
        </body>
    </v-layout>
</template>

<script>
import axios from 'axios';
export default {
    name: 'gateinpass',
    data() {
        return {
            gin_pass_details: [],
            pass_no: null,
            in_date: null,
            port_out_time: null,
            igm_no: null,
            igm_date: null,
            bl_no: null,
            bl_date: null,
            vessel: null,
            voyage: null,
            line: null,
            transporter: null,
            cargo: null,
            importer: null,
            is_scanned: null,
            eir_no: null,
            job_order_no: null,
        }
    },
    mounted:function() {
        this.getData()
    },
    methods: {
      getData: function () {
            this.loading = true;
            this.API_URL = this.$hostname + "/passes/gate_ins?gin_id=837" 
            // + this.$route.params.gin_id
            axios.get(this.API_URL, { headers: {"Authorization" : 'jwt ' + localStorage.jwt} })
            .then((response) => {
                this.loading = false;
                this.gin_pass_details = response.data;
            }, (error) => {
                this.loading = false;
                this.error = true;
            })
        }
    }
}
</script>